import React, {useEffect} from 'react';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';
import {UserInterfaceActions} from '../../Context/UserInterface/UserInterfaceActionTypes';
import {DialogStatus} from '../../../Enums';
import SpineWidthChangeNotification from './CoverSpineWidthChangeNotification';
import PageCountChangeNotification from './PageCountChangedNotification';
import PicturesIgnoredBySmartDesignNotification from './PicturesIgnoredBySmartDesignNotification';
import ProjectLayoutChangeNotification from './ProjectLayoutChangeNotification';
import AlternativeProductsUnavailableNotification from './AlternativeProductsUnavailableNotification';
import {useUserFeedback} from '../../Context/UserFeedback/UserFeedbackContext';
import {Alert} from '@taopix/taopix-design-system';
import {UserFeedbackActions} from '../../Context/UserFeedback/UserFeedbackActionTypes';
import SubmittedChangesNotification from './SubmittedChangesNotification';

const NotificationManager = () => {
  const ui = useUiState();
  const userFeedback = useUserFeedback();

  useEffect(() => {
    ui.dispatch(
      UserInterfaceActions.setDialogStatus({
        coverSpineChangeNotification:
          ui.state.flags.coverNeedsChecking &&
          [DialogStatus.Open, DialogStatus.Closed].includes(
            ui.state.dialogs.coverSpineChangeNotification
          )
            ? DialogStatus.Open
            : ui.state.dialogs.coverSpineChangeNotification,
        pageCountChangeNotification: ui.state.flags.pageCountChanged
          ? DialogStatus.Open
          : ui.state.dialogs.pageCountChangeNotification,
      })
    );
  }, [
    ui.state.flags.coverNeedsChecking,
    ui.state.flags.pageCountChanged,
    ui.state.dialogs.coverSpineChangeNotification,
  ]);

  if (
    DialogStatus.Open === ui.state.dialogs.coverSpineChangeNotification &&
    ui.state.flags.coverNeedsChecking
  ) {
    return <SpineWidthChangeNotification open={true} />;
  } else if (
    DialogStatus.Open === ui.state.dialogs.pageCountChangeNotification &&
    ui.state.flags.pageCountChanged
  ) {
    return <PageCountChangeNotification open={true} />;
  } else if (DialogStatus.Open === ui.state.dialogs.picturesIgnoredBySmartDesignNotification) {
    return <PicturesIgnoredBySmartDesignNotification open={true} />;
  } else if (DialogStatus.Open === ui.state.dialogs.projectLayoutChangeNotification) {
    return <ProjectLayoutChangeNotification open={true} />;
  } else if (DialogStatus.Open === ui.state.dialogs.alternativeProductsUnavailable) {
    return <AlternativeProductsUnavailableNotification open={true} />;
  } else if (DialogStatus.Open === ui.state.dialogs.submittedChangesNotification) {
    return <SubmittedChangesNotification open={true} />;
  } else if (userFeedback.state.open) {
    return (
      <Alert
        id={'userfeedback-notification'}
        open={true}
        type={userFeedback.state.type}
        showTitle={userFeedback.state.showHeader}
        title={userFeedback.state.title}
        message={userFeedback.state.message}
        onClose={() => {
          userFeedback.dispatch(UserFeedbackActions.closeFeedback());
        }}
      ></Alert>
    );
  }

  return <></>;
};

export default NotificationManager;
